import ContactForm from "../components/contactform";

export default function Contact() {
    return (
        <div className="min-h-screen">
            <ContactForm />
        </div>
    );
}
